import React, { useState } from "react";
import classnames from "classnames";
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Row,
  UncontrolledDropdown,
  Accordion,
  AccordionItem,
  Button,
  Collapse,
} from "reactstrap";
import Select from "react-select";

import { Link } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";
// import { useEffect } from "react";

const SingleOptions = [
  { value: "John Doe", label: "John Doe" },
  { value: "Mrs. Dennis Schulist", label: "Mrs. Dennis Schulist" },
  { value: "Mark Smith", label: "Mark Smith" },
  { value: "Roman Dean", label: "Roman Dean" },
  { value: "Chris Smith", label: "Chris Smith" },
  { value: "Natalya", label: "Natalya" },
];

const AddCases = () => {
  document.title = "CASE INFORMATION | ApprentAI";
  const [col1, setcol1] = useState(true);
  const [col2, setcol2] = useState(false);
  const [col3, setcol3] = useState(false);

  const [selectedMulti, setselectedMulti] = useState(null);
  console.log("selectedMulti", selectedMulti);

  function handleMulti(selectedMulti) {
    setselectedMulti(selectedMulti);
  }

  const [checkBoxes, setCheckBoxes] = useState({
    leadAttorney: [],
  });
  const [isReviewers, setIsReviewers] = useState({
    reviewers: [],
  });
  const [isReviewManager, setIsReviewManager] = useState({
    reviewManager: [],
  });
  console.log("leadarray", checkBoxes.leadAttorney);
  console.log("reviewers", isReviewers.reviewers);

  const handleLeadAttroney = (e) => {
    const { value, checked } = e.target;
    const { leadAttorney } = checkBoxes;
    if (checked) {
      setCheckBoxes({
        leadAttorney: [...leadAttorney, value],
      });
    } else {
      setCheckBoxes({
        leadAttorney: leadAttorney.filter((e) => e !== value),
      });
    }
    console.log(e.target.value);
  };

  const handleReviewers = (e) => {
    const { value, checked } = e.target;
    const { reviewers } = isReviewers;
    if (checked) {
      setIsReviewers({
        reviewers: [...reviewers, value],
      });
    } else {
      setIsReviewers({
        reviewers: reviewers.filter((e) => e !== value),
      });
    }
    console.log(e.target.value);
  };

  // useEffect(() => {}, [checkBoxes.leadAttorney, isReviewers.reviewers]);

  // const handleReviewManager = (e) => {
  //   const { value, checked } = e.target;
  //   const { reviewManager } = isReviewManager;
  //   if (checked) {
  //     setIsReviewManager({
  //       reviewManager: [...reviewManager, value],
  //     });
  //   } else {
  //     setIsReviewManager({
  //       reviewManager: reviewManager.filter((e) => e !== value),
  //     });
  //   }
  //   console.log(e.target.value);
  // };

  const t_col1 = () => {
    setcol1(!col1);
    setcol2(false);
    setcol3(false);
  };

  const t_col2 = () => {
    setcol2(!col2);
    setcol1(false);
    setcol3(false);
  };

  const t_col3 = () => {
    setcol3(!col3);
    setcol1(false);
    setcol2(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="CASE INFORMATION" pageTitle="Dashboards" />
        <Row>
          <Col>
            <form onSubmit={handleSubmit}>
              <Card>
                <CardBody>
                  <Row className="g-4">
                    <Col md={6}>
                      <Row className="g-4">
                        <Col xxl={3} md={6}>
                          <div>
                            <Label htmlFor="partyone" className="form-label">
                              Party One
                            </Label>
                            <Input
                              type="text"
                              placeholder="ex: Lorem Ipsum"
                              className="form-control"
                              id="partyone"
                            />
                          </div>
                        </Col>
                        <Col xxl={3} md={6}>
                          <div>
                            <Label htmlFor="partytwo" className="form-label">
                              Party Two
                            </Label>
                            <Input
                              type="text"
                              placeholder="ex: Lorem Ipsum"
                              className="form-control"
                              id="partytwo"
                            />
                          </div>
                        </Col>
                        <Col xxl={3} md={6}>
                          <div>
                            <Label htmlFor="nickname" className="form-label">
                              Nickname
                            </Label>
                            <Input
                              type="text"
                              placeholder="ex: Lorem Ipsum"
                              className="form-control"
                              id="nickname"
                            />
                          </div>
                        </Col>
                        <Col xxl={3} md={6}>
                          <div>
                            <Label
                              htmlFor="clientcontactname"
                              className="form-label"
                            >
                              Clients Contact Name
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="ex: Lorem Ipsum"
                              id="clientcontactname"
                            />
                          </div>
                        </Col>
                        <Col xxl={3} md={6}>
                          <div>
                            <Label htmlFor="stage" className="form-label">
                              Stage
                            </Label>
                            <Input
                              type="text"
                              placeholder="ex: Lorem Ipsum"
                              className="form-control"
                              id="stage"
                            />
                          </div>
                        </Col>
                        <Col xxl={3} md={6}>
                          <div>
                            <Label
                              htmlFor="daterecieved"
                              className="form-label"
                            >
                              Date Recieved
                            </Label>
                            <Input
                              type="date"
                              placeholder="ex: Lorem Ipsum"
                              className="form-control"
                              id="daterecieved"
                            />
                          </div>
                        </Col>
                        <Col xxl={3} md={6}>
                          <div>
                            <Label htmlFor="datestarted" className="form-label">
                              Date Started
                            </Label>
                            <Input
                              type="date"
                              className="form-control"
                              id="datestarted"
                              placeholder="ex: Lorem Ipsum"
                            />
                          </div>
                        </Col>
                        <Col xxl={3} md={6}>
                          <div>
                            <Label
                              htmlFor="previousowner"
                              className="form-label"
                            >
                              Previous Owner
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="previousowner"
                              placeholder="ex: Lorem Ipsum"
                            />
                          </div>
                        </Col>
                        <Col className="mb-4">
                          <UncontrolledDropdown>
                            <DropdownToggle
                              tag="button"
                              className="btn btn-secondary"
                              id="dropdownMenuButton"
                            >
                              Case Stages
                              <i className="mdi mdi-chevron-down"></i>
                            </DropdownToggle>
                            <DropdownMenu
                              style={{ boxShadow: "0 0 4px rgba(0,0,0,0.6)" }}
                            >
                              <DropdownItem>1. Filing of Plaint</DropdownItem>
                              <DropdownItem>2. Issuing of Summons</DropdownItem>
                              <DropdownItem>
                                3. The appearance of the Parties to the Dispute
                              </DropdownItem>
                              <DropdownItem>4. Filing of Plaint</DropdownItem>
                              <DropdownItem>5. Issuing of Summons</DropdownItem>
                              <DropdownItem>
                                6. The appearance of the Parties to the Dispute
                              </DropdownItem>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <div className="live-preview">
                        <Accordion
                          id="default-accordion-example"
                          className="accordion-fill-primary"
                        >
                          <AccordionItem>
                            <h2 className="accordion-header" id="headingOne">
                              <button
                                className={classnames("accordion-button", {
                                  collapsed: !col1,
                                })}
                                type="button"
                                onClick={t_col1}
                                style={{ cursor: "pointer" }}
                              >
                                {checkBoxes.leadAttorney.length > 0 ? (
                                  <>
                                    {" "}
                                    Add Lead Attorney (
                                    {checkBoxes.leadAttorney.length} selected)
                                  </>
                                ) : (
                                  "Add Lead Attorney"
                                )}
                              </button>
                            </h2>

                            <Collapse
                              isOpen={col1}
                              className="accordion-collapse"
                              id="collapseOne"
                            >
                              <div className="accordion-body">
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleLeadAttroney}
                                    value=" John Doe"
                                    id="formCheck1"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck1"
                                  >
                                    John Doe
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleLeadAttroney}
                                    value=" James Bond"
                                    id="formCheck2"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck2"
                                  >
                                    James Bond
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleLeadAttroney}
                                    value="Alex Hales"
                                    id="formCheck3"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck3"
                                  >
                                    Alex Hales
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleLeadAttroney}
                                    value=" Leanne Graham"
                                    id="formCheck4"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck4"
                                  >
                                    Leanne Graham
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleLeadAttroney}
                                    value=" Romaguera-Crona"
                                    id="formCheck5"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck5"
                                  >
                                    Romaguera-Crona
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleLeadAttroney}
                                    value="Ervin Howell"
                                    id="formCheck6"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck6"
                                  >
                                    Ervin Howell
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleLeadAttroney}
                                    value=" Clementine Bauch"
                                    id="formCheck7"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck7"
                                  >
                                    Clementine Bauch
                                  </Label>
                                </div>
                              </div>
                            </Collapse>
                          </AccordionItem>
                          <AccordionItem>
                            <h2 className="accordion-header" id="headingTwo">
                              <button
                                className={classnames("accordion-button", {
                                  collapsed: !col2,
                                })}
                                type="button"
                                onClick={t_col2}
                                style={{ cursor: "pointer" }}
                              >
                                {isReviewers.reviewers.length > 0 ? (
                                  <>
                                    {" "}
                                    Add Reviewers (
                                    {isReviewers.reviewers.length} selected)
                                  </>
                                ) : (
                                  <>Add Reviewers</>
                                )}
                              </button>
                            </h2>

                            <Collapse
                              isOpen={col2}
                              className="accordion-collapse"
                            >
                              <div className="accordion-body">
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewers}
                                    value="Nicholas Runolfsdottir V"
                                    id="formCheck8"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck8"
                                  >
                                    Nicholas Runolfsdottir V
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewers}
                                    value="Glenna Reichert"
                                    id="formCheck9"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck9"
                                  >
                                    Glenna Reichert
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewers}
                                    value="Clementina DuBuque"
                                    id="formCheck10"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck10"
                                  >
                                    Clementina DuBuque
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewers}
                                    value="Patricia Lebsack"
                                    id="formCheck11"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck11"
                                  >
                                    Patricia Lebsack
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewers}
                                    value="Clementine Bauch"
                                    id="formCheck12"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck12"
                                  >
                                    Clementine Bauch
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewers}
                                    value="Ervin Howell"
                                    id="formCheck13"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck13"
                                  >
                                    Ervin Howell
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewers}
                                    value="Kattie Turnpike"
                                    id="formCheck14"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck14"
                                  >
                                    Kattie Turnpike
                                  </Label>
                                </div>
                              </div>
                            </Collapse>
                          </AccordionItem>
                          <AccordionItem>
                            <h2 className="accordion-header" id="headingThree">
                              <button
                                className={classnames("accordion-button", {
                                  collapsed: !col3,
                                })}
                                type="button"
                                onClick={t_col3}
                                style={{ cursor: "pointer" }}
                              >
                                Change Review Manager
                                {/* {selectedMulti.length > 0 ? (
                                  <>
                                    Change Review Manager (
                                    {selectedMulti.length})
                                  </>
                                ) : (
                                  <>Change Review Manager</>
                                )} */}
                                {/* {isReviewManager.reviewManager.length > 0 ? (
                                  <>
                                    {" "}
                                    Change Review Manager (
                                    {isReviewManager.reviewManager.length}{" "}
                                    selected)
                                  </>
                                ) : (
                                  <>Change Review Manager</>
                                )} */}
                              </button>
                            </h2>
                            <Collapse
                              isOpen={col3}
                              className="accordion-collapse"
                            >
                              <div className="accordion-body">
                                <Col lg={12}>
                                  <div className="mb-3">
                                    {/* <Label
                                      htmlFor="choices-multiple-default"
                                      className="form-label text-muted"
                                    >
                                      Default
                                    </Label> */}
                                    <Select
                                      value={selectedMulti}
                                      isMulti={true}
                                      onChange={() => {
                                        handleMulti();
                                      }}
                                      options={SingleOptions}
                                    />
                                  </div>
                                </Col>
                                {/* <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewManager}
                                    value="Kurtis Weissnat"
                                    id="formCheck15"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck15"
                                  >
                                    Kurtis Weissnat
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewManager}
                                    value="Mrs. Dennis Schulist"
                                    id="formCheck16"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck16"
                                  >
                                    Mrs. Dennis Schulist
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewManager}
                                    value="Chelsey Dietrich"
                                    id="formCheck17"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck17"
                                  >
                                    Chelsey Dietrich
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewManager}
                                    value="Patricia Lebsack"
                                    id="formCheck18"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck18"
                                  >
                                    Patricia Lebsack
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewManager}
                                    value="Clementine Bauch"
                                    id="formCheck19"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck19"
                                  >
                                    Clementine Bauch
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewManager}
                                    value="Ervin Howell"
                                    id="formCheck20"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck20"
                                  >
                                    Ervin Howell
                                  </Label>
                                </div>
                                <div className="form-check mb-3">
                                  <Input
                                    className="form-check-input"
                                    type="checkbox"
                                    onChange={handleReviewManager}
                                    value="Leanne Graham"
                                    id="formCheck21"
                                  />
                                  <Label
                                    className="form-check-label"
                                    for="formCheck21"
                                  >
                                    Leanne Graham
                                  </Label>
                                </div> */}
                              </div>
                            </Collapse>
                          </AccordionItem>
                        </Accordion>
                      </div>
                    </Col>

                    <Col md={12} className="d-flex justify-content-end">
                      {/* <input
                        type="Submit"
                        className="btn btn-primary"
                        value="Save and Upload Data"
                        Link
                      /> */}
                      <Link
                        to="/data-stamp-uploading"
                        className="btn btn-primary"
                        type="submit"
                      >
                        Save and Upload Data
                      </Link>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AddCases;
